import React, { useState, useEffect } from 'react';
import IntlMessages from '@iso/components/utility/intlMessages';
import AssetModalWrapper from './AssetModal.styles';
import { Form, Input, Button, Select, Row, Col, DatePicker, InputNumber, Tabs, Upload, Space, Card, Switch, Popover } from 'antd';
import Loader from '@iso/components/utility/loader';
import { useSelector } from 'react-redux';
import { assetService, activityService, attachment, userService } from '@iso/services';
import moment from 'moment';
import _ from 'lodash';
import { dateHelper } from '@iso/lib/helpers/dateHelper';
import L from 'leaflet';
import inside from 'point-in-polygon';
import { assetCategories } from '@iso/constants/assetCategories';
import { inventoryTypes } from '@iso/constants/inventoryTypes';
import { assetStates } from '@iso/constants/assetStates';
import { fuelTypes } from '@iso/constants/fuelTypes';
import { fuelContainerUnits, getFuelContainerUnitSuffix } from '@iso/constants/fuelContainerUnits';
import AddAssetHistoryModal from './AddAssetHistoryModal';
import AssetHistory from './AssetHistory';
import styled from "styled-components";
import { treatmentRates } from '@iso/constants/treatmentRates';
import { FORMULATION_TYPES } from '@iso/constants/formulationTypes';
import SensorTab from './SensorTab';
import { UploadOutlined, PlusOutlined, CalendarOutlined, UserOutlined } from '@ant-design/icons';
import { apiEndpoint } from '@iso/lib/helpers/endpoint';
import { authHeader } from '@iso/lib/helpers/authHeader';
import FormTab from './FormTab';

const { Option } = Select;
const { TabPane } = Tabs;

const RATE_PER_OPTIONS = [
  { value: 'per_100l', label: 'Rate per 100L' },
  { value: 'per_hectare', label: 'Rate per hectare' },
];

const RATE_UNIT_OPTIONS = [
  { value: 'kg', label: 'Kg' },
  { value: 'l', label: 'L' },
  { value: 'ml', label: 'mL' },
  { value: 'g', label: 'g' },
];

const EditFuelModal = (props) => {
  const [form] = Form.useForm();
  const [addHistoryForm] = Form.useForm();
  const [fields, setFields] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [assetData, setAssetData] = useState({});
  const [assetHistory, setAssetHistory] = useState([]);
  const [visibleHistory, setVisibleHistory] = useState(false);
  const [loadingHistory, setLoadingHistory] = useState(false);
  const activePermission = useSelector((state) => state.permission.activePermission);
  const [permitAttachmentLists, setPermitAttachmentLists] = useState([]);
  const [attachmentFileList, setAttachmentFileList] = useState([]);
  const [attachmentId, setAttachmentId] = useState([]);
  const [users, setUsers] = useState([]);
  const dateFormat = "DD/MM/YYYY";
  const assetType = Form.useWatch(['asset', 'type'], form);
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || '';

  const currentAssetType = assetType || assetData.type;
  const isChemical = currentAssetType === 'chemical';

  const extractFileName = (path = '') => {
    if (!path) {
      return '';
    }
    const segments = path.split('/');
    return segments[segments.length - 1] || path;
  };

  const buildAttachmentUrl = (attachmentData) => {
    if (!attachmentData) {
      return undefined;
    }

    const rawUrl = attachmentData.full_path || attachmentData.url;
    if (!rawUrl) {
      return undefined;
    }

    if (/^https?:\/\//i.test(rawUrl)) {
      return rawUrl;
    }

    return `${apiBaseUrl}${rawUrl.startsWith('/') ? '' : '/'}${rawUrl}`;
  };

  const updateDataAssetHistory = React.useCallback((asset_id, modal_type) => {
      activityService.getList(asset_id, modal_type).then(res => {
        if(res.code === '0000'){
          setAssetHistory(res.activities.reverse());
          //setLoading(false);
        }
      });
  }, [assetHistory]);
  
  useEffect(() => {
    setAssetData(props.dataAsset);

    var arrAtt = [];
    if (props.dataAsset.attachment?.length > 0) {
      _.forEach(props.dataAsset.attachment, (att) => {
        const resolvedUrl = buildAttachmentUrl(att);
        arrAtt.push({
          uid: att.id,
          name: extractFileName(att.full_path || att.url || `attachment-${att.id}`),
          status: 'done',
          url: resolvedUrl,
          attachmentData: att,
        });
      });
      setAttachmentFileList(arrAtt);
    } else {
      setAttachmentFileList([]);
    }
  }, [props.dataAsset]);

  useEffect(() => {
    if (props.visibleAssetFuel && props.propertyId) {
      userService.getUserForProperty(props.propertyId).then(res => {
        if (res && res.code === '0000') {
          setUsers(res.users || []);
        }
      }).catch(err => {
        console.error('Error loading users:', err);
      });
    }
  }, [props.visibleAssetFuel, props.propertyId]);

  const uploadProps = {
    name: "Attachment[file]",
    action: apiEndpoint.attachments,
    headers: authHeader(true),
    listType: "picture",
    defaultFileList: [...attachmentFileList],
    multiple: true,
    onChange: (response) => {
      if (response.file && response.file.status == "done") {
        response.file.attachmentData = response.file.response.attachment;
        setAttachmentId((attachmentId) => [
          ...attachmentId,
          response.file.response.attachment.id,
        ]);
      }
      setAttachmentFileList(response.fileList);
    },
    onRemove: (file) => {
      attachment.destroy(file.uid);
    },
  };

  const handleExpiryDateChange = (attachmentId, newDate) => {
    attachment.updateAttachment(attachmentId, { expiry_date: newDate ?? '' }).then(res => {
      if (res && res.code === '0000') {
        setAttachmentFileList(prev => prev.map(f => {
          if ((f.attachmentData && f.attachmentData.id === attachmentId) || f.uid === attachmentId) {
            return { ...f, attachmentData: { ...f.attachmentData, expiry_date: newDate } };
          }
          return f;
        }));
      }
    });
  };

  const handleUserChange = (attachmentId, userId) => {
    attachment.updateAttachment(attachmentId, { user_id: userId ?? '' }).then(res => {
      if (res && res.code === '0000') {
        const updatedUser = res.attachment?.user || null;
        setAttachmentFileList(prev => prev.map(f => {
          if ((f.attachmentData && f.attachmentData.id === attachmentId) || f.uid === attachmentId) {
            return { ...f, attachmentData: { ...f.attachmentData, user_id: userId, user: updatedUser } };
          }
          return f;
        }));
      }
    });
  };

  const attachmentItemRender = (originNode, file) => {
    if (file.status !== 'done') return originNode;
    const expiryDate = file.attachmentData?.expiry_date;
    const hasExpiry = !!expiryDate;
    const assignedUser = file.attachmentData?.user;
    const hasUser = !!assignedUser;
    const userName = hasUser ? `${assignedUser.name || ''} ${assignedUser.surname || ''}`.trim() : '';
    return (
      <div style={{ position: 'relative' }}>
        {originNode}
        <Popover
          trigger="click"
          placement="left"
          content={
            <div style={{ width: 220 }}>
              <div style={{ marginBottom: 4, fontSize: 12, color: '#888' }}>Assigned user</div>
              <Select
                size="small"
                allowClear
                placeholder="Select user"
                value={file.attachmentData?.user_id || undefined}
                onChange={(value) => handleUserChange(
                  file.attachmentData?.id || file.uid,
                  value || null
                )}
                style={{ width: '100%' }}
              >
                {users.map(u => (
                  <Select.Option key={u.id} value={u.id}>
                    {`${u.name || ''} ${u.surname || ''}`.trim()}
                  </Select.Option>
                ))}
              </Select>
            </div>
          }
        >
          <UserOutlined
            title={hasUser ? `User: ${userName}` : 'Assign user'}
            style={{
              position: 'absolute',
              top: '50%',
              right: 52,
              transform: 'translateY(-50%)',
              fontSize: 15,
              cursor: 'pointer',
              color: hasUser ? '#0b2a1b' : '#d9d9d9',
              padding: 6,
              borderRadius: 4,
              zIndex: 1,
              transition: 'color 0.2s',
            }}
          />
        </Popover>
        <Popover
          trigger="click"
          placement="left"
          content={
            <div style={{ width: 220 }}>
              <div style={{ marginBottom: 4, fontSize: 12, color: '#888' }}>Expiry date</div>
              <DatePicker
                size="small"
                format={dateFormat}
                placeholder="Select date"
                value={expiryDate ? moment(expiryDate) : null}
                onChange={(date) => handleExpiryDateChange(
                  file.attachmentData?.id || file.uid,
                  date ? dateHelper.dateForAPI(date) : null
                )}
                style={{ width: '100%' }}
              />
            </div>
          }
        >
          <CalendarOutlined
            title={hasExpiry ? `Expires: ${moment(expiryDate).format(dateFormat)}` : 'Set expiry date'}
            style={{
              position: 'absolute',
              top: '50%',
              right: 28,
              transform: 'translateY(-50%)',
              fontSize: 15,
              cursor: 'pointer',
              color: hasExpiry ? '#0b2a1b' : '#d9d9d9',
              padding: 6,
              borderRadius: 4,
              zIndex: 1,
              transition: 'color 0.2s',
            }}
          />
        </Popover>
      </div>
    );
  };

  const getRandomLatLng = (coordinates) => {
    var polygon = L.polygon([
      coordinates
    ]);
    var bounds = polygon.getBounds();
    var x_max = bounds.getEast();
    var x_min = bounds.getWest();
    var y_max = bounds.getSouth();
    var y_min = bounds.getNorth();
    var lat=0,lng = 0;
    var count = 0;
    var area = polygon.getLatLngs()[0].map(function(point){
      return [point.lat, point.lng]            
    });

    while(!inside([lat, lng], area)){
      lat = y_min + (Math.random() * (y_max - y_min));
      lng = x_min + (Math.random() * (x_max - x_min));
      count+=1;
      if(count==100){
        break;
      }      
    }            

    return new L.LatLng(
          lat,
          lng
    );
  }

  const handlePermitAttachmentChange = (index, info) => {
    const assetValue = form.getFieldValue('asset') || {};
    const permitsValue = (assetValue.permits || []).map((item) => ({ ...item }));
    if (!permitsValue[index]) {
      permitsValue[index] = {};
    }

    if (info.file.status === 'removed') {
      permitsValue[index].attachment_id = null;
      permitsValue[index].attachment = null;
    }

    if (info.file.status === 'done' && info.file.response && info.file.response.attachment) {
      const uploadedAttachment = info.file.response.attachment;
      permitsValue[index].attachment_id = uploadedAttachment.id;
      permitsValue[index].attachment = uploadedAttachment;
    }

    const normalizedFileList = info.fileList.map((file) => {
      if (file.status === 'uploading') {
        return file;
      }
      const attachmentData = file.response?.attachment || permitsValue[index]?.attachment;
      if (attachmentData) {
        const attachmentPath = attachmentData.full_path || buildAttachmentUrl(attachmentData) || attachmentData.url;
        return {
          uid: `${attachmentData.id}`,
          name: file.name || extractFileName(attachmentPath || ''),
          status: 'done',
          url: attachmentPath,
        };
      }
      if (file.url) {
        return file;
      }
      return file;
    });

    setPermitAttachmentLists((prev) => {
      const next = [...prev];
      next[index] = normalizedFileList;
      return next;
    });

    form.setFieldsValue({
      asset: {
        ...assetValue,
        permits: permitsValue,
      },
    });
  };

  const renderPermitTab = () => (
    <Form.List name={['asset', 'permits']}>
      {(fields, { add, remove }) => (
        <Space direction="vertical" style={{ width: '100%' }}>
          <Button
            type="dashed"
            icon={<PlusOutlined />}
            onClick={() => {
              add({});
              setPermitAttachmentLists((prev) => [...prev, []]);
            }}
          >
            Add permit
          </Button>
          {fields.length === 0 ? (
            <span>No permits added.</span>
          ) : (
            fields.map((field, index) => (
              <Card
                key={field.key}
                size="small"
                title={`Permit ${index + 1}`}
                style={{ width: '100%' }}
                extra={
                  <Button
                    danger
                    size="small"
                    onClick={() => {
                      remove(field.name);
                      setPermitAttachmentLists((prev) =>
                        prev.filter((_, idx) => idx !== field.name)
                      );
                    }}
                  >
                    Remove
                  </Button>
                }
              >
                <Form.Item name={[field.name, 'id']} hidden>
                  <Input />
                </Form.Item>
                <Row gutter={16}>
                  <Col xs={24} md={8}>
                    <Form.Item
                      name={[field.name, 'crop_usage']}
                      label="Crop usage"
                      rules={[{ required: true, message: 'This field is required' }]}
                    >
                      <Input placeholder="e.g. Wheat" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={8}>
                    <Form.Item
                      name={[field.name, 'rate']}
                      label="Rate"
                    >
                      <InputNumber min={0} style={{ width: '100%' }} placeholder="Rate" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={8}>
                    <Form.Item
                      name={[field.name, 'rate_per']}
                      label="Rate per"
                    >
                      <Select placeholder="Select rate per" allowClear>
                        {RATE_PER_OPTIONS.map((option) => (
                          <Option key={option.value} value={option.value}>
                            {option.label}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col xs={24} md={12}>
                    <Form.Item label="Min rate">
                      <Input.Group compact>
                        <Form.Item
                          name={[field.name, 'min_rate']}
                          noStyle
                        >
                          <InputNumber min={0} style={{ width: 'calc(100% - 70px)' }} placeholder="Min rate" />
                        </Form.Item>
                        <Form.Item
                          name={[field.name, 'min_rate_unit']}
                          noStyle
                        >
                          <Select placeholder="Unit" allowClear style={{ width: "70px" }}>
                            {RATE_UNIT_OPTIONS.map((unit) => (
                              <Option key={unit.value} value={unit.value}>
                                {unit.label}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Input.Group>
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12}>
                    <Form.Item label="Max rate">
                      <Input.Group compact>
                        <Form.Item
                          name={[field.name, 'max_rate']}
                          noStyle
                        >
                          <InputNumber min={0} style={{ width: 'calc(100% - 70px)' }} placeholder="Max rate" />
                        </Form.Item>
                        <Form.Item
                          name={[field.name, 'max_rate_unit']}
                          noStyle
                        >
                          <Select placeholder="Unit" allowClear style={{ width: "70px" }}>
                            {RATE_UNIT_OPTIONS.map((unit) => (
                              <Option key={unit.value} value={unit.value}>
                                {unit.label}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Input.Group>
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col xs={24} md={12}>
                    <Form.Item
                      name={[field.name, 'whp_harvest']}
                      label="WHP - Harvest"
                    >
                      <Input placeholder="WHP - Harvest" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12}>
                    <Form.Item
                      name={[field.name, 'whp_grazing']}
                      label="WHP - Grazing"
                    >
                      <Input placeholder="WHP - Grazing" />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col xs={24} md={12}>
                    <Form.Item
                      name={[field.name, 'permit_code']}
                      label="Permit ID"
                    >
                      <Input placeholder="Permit ID" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12}>
                    <Form.Item
                      name={[field.name, 'expiry_date']}
                      label="Expiry date"
                    >
                      <DatePicker style={{ width: '100%' }} />
                    </Form.Item>
                  </Col>
                </Row>
                <Form.Item name={[field.name, 'attachment_id']} hidden>
                  <Input />
                </Form.Item>
                <Form.Item label="Attachment">
                  <Upload
                    name="Attachment[file]"
                    action={apiEndpoint.attachments}
                    headers={authHeader(true)}
                    multiple={false}
                    maxCount={1}
                    fileList={permitAttachmentLists[field.name] || []}
                    onChange={(info) => handlePermitAttachmentChange(field.name, info)}
                  >
                    <Button icon={<UploadOutlined />}>Upload</Button>
                  </Upload>
                </Form.Item>
              </Card>
            ))
          )}
        </Space>
      )}
    </Form.List>
  );

  const renderCropTab = () => (
    <Form.List name={['asset', 'crops']}>
      {(fields, { add, remove }) => (
        <Space direction="vertical" style={{ width: '100%' }}>
          <Button
            type="dashed"
            icon={<PlusOutlined />}
            onClick={() => add({ allow_use: true })}
          >
            Add crop
          </Button>
          {fields.length === 0 ? (
            <span>No crops defined.</span>
          ) : (
            fields.map((field, index) => (
              <Card
                key={field.key}
                size="small"
                title={`Crop ${index + 1}`}
                style={{ width: '100%' }}
                extra={
                  <Button danger size="small" onClick={() => remove(field.name)}>
                    Remove
                  </Button>
                }
              >
                <Form.Item name={[field.name, 'id']} hidden>
                  <Input />
                </Form.Item>
                <Row gutter={16}>
                  <Col xs={24} md={8}>
                    <Form.Item
                      name={[field.name, 'crop_name']}
                      label="Crop name"
                      rules={[{ required: true, message: 'This field is required' }]}
                    >
                      <Input placeholder="Crop name" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={8}>
                    <Form.Item
                      name={[field.name, 'rate']}
                      label="Rate"
                    >
                      <InputNumber min={0} style={{ width: '100%' }} placeholder="Rate" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={8}>
                    <Form.Item
                      name={[field.name, 'rate_per']}
                      label="Rate per"
                    >
                      <Select placeholder="Select rate per" allowClear>
                        {RATE_PER_OPTIONS.map((option) => (
                          <Option key={option.value} value={option.value}>
                            {option.label}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col xs={24} md={12}>
                    <Form.Item label="Min rate">
                      <Input.Group compact>
                        <Form.Item
                          name={[field.name, 'min_rate']}
                          noStyle
                        >
                          <InputNumber min={0} style={{ width: 'calc(100% - 120px)' }} placeholder="Min rate" />
                        </Form.Item>
                        <Form.Item
                          name={[field.name, 'min_rate_unit']}
                          noStyle
                        >
                          <Select placeholder="Unit" allowClear style={{ width: 90 }}>
                            {RATE_UNIT_OPTIONS.map((unit) => (
                              <Option key={unit.value} value={unit.value}>
                                {unit.label}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Input.Group>
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12}>
                    <Form.Item label="Max rate">
                      <Input.Group compact>
                        <Form.Item
                          name={[field.name, 'max_rate']}
                          noStyle
                        >
                          <InputNumber min={0} style={{ width: 'calc(100% - 120px)' }} placeholder="Max rate" />
                        </Form.Item>
                        <Form.Item
                          name={[field.name, 'max_rate_unit']}
                          noStyle
                        >
                          <Select placeholder="Unit" allowClear style={{ width: 90 }}>
                            {RATE_UNIT_OPTIONS.map((unit) => (
                              <Option key={unit.value} value={unit.value}>
                                {unit.label}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Input.Group>
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col xs={24} md={12}>
                    <Form.Item
                      name={[field.name, 'whp_harvest']}
                      label="WHP - Harvest"
                    >
                      <Input placeholder="WHP - Harvest" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12}>
                    <Form.Item
                      name={[field.name, 'whp_grazing']}
                      label="WHP - Grazing"
                    >
                      <Input placeholder="WHP - Grazing" />
                    </Form.Item>
                  </Col>
                </Row>
                <Form.Item
                  name={[field.name, 'allow_use']}
                  label="Allow use on crop"
                  valuePropName="checked"
                >
                  <Switch checkedChildren="Allow" unCheckedChildren="Disallow" />
                </Form.Item>
              </Card>
            ))
          )}
        </Space>
      )}
    </Form.List>
  );
  
  const cancelModal = () => {
    props.cancelEditModal();
    setLoading(false);
    form.resetFields();
    setPermitAttachmentLists([]);
  }

  const handleSubmit = (e) => {
    setLoading(true);

    form
      .validateFields()
      .then(values => {
        onStore(values);
      })
      .catch(info => {
        console.log('Validate Failed:', info);
        setLoading(false);
      });
  }

  const onStore = (values) => {
    const selectedObject = _.find(props.primaryObjects, (object) => {
      return object.id === values.asset.primary_object_id;
    });

    let point = assetData.point || null;
    if (selectedObject && (!assetData.id || assetData.primary_object_id != selectedObject.id)) {
      point = getRandomLatLng(selectedObject.area);
    }

    const permitsPayload = (values.asset.permits || []).map((permit) => {
      const payload = {
        crop_usage: permit.crop_usage,
        rate: permit.rate,
        rate_per: permit.rate_per || null,
        min_rate: permit.min_rate ?? null,
        min_rate_unit: permit.min_rate_unit || null,
        max_rate: permit.max_rate ?? null,
        max_rate_unit: permit.max_rate_unit || null,
        whp_harvest: permit.whp_harvest || null,
        whp_grazing: permit.whp_grazing || null,
        permit_code: permit.permit_code ?? permit.permit_id ?? null,
        expiry_date: permit.expiry_date ? dateHelper.dateForAPI(permit.expiry_date) : null,
        attachment_id: permit.attachment_id || null,
      };
      if (permit.id) {
        payload.id = permit.id;
      }
      return payload;
    }).filter((permit) => permit.crop_usage);

    const cropsPayload = (values.asset.crops || []).map((crop) => {
      const payload = {
        crop_name: crop.crop_name,
        rate: crop.rate,
        rate_per: crop.rate_per || null,
        min_rate: crop.min_rate ?? null,
        min_rate_unit: crop.min_rate_unit || null,
        max_rate: crop.max_rate ?? null,
        max_rate_unit: crop.max_rate_unit || null,
        whp_harvest: crop.whp_harvest || null,
        whp_grazing: crop.whp_grazing || null,
        allow_use: crop.allow_use !== undefined ? !!crop.allow_use : true,
      };
      if (crop.id) {
        payload.id = crop.id;
      }
      return payload;
    }).filter((crop) => crop.crop_name);

    delete values.asset.permits;
    delete values.asset.crops;

    const data = {
      facility: {
        ...values.asset,
        date_of_purchase: values.asset.date_of_purchase ? dateHelper.dateForAPI(values.asset.date_of_purchase) : '',
        manufacture_date: values.asset.manufacture_date ? dateHelper.dateForAPI(values.asset.manufacture_date) : '',
        expiry_date: values.asset.expiry_date ? dateHelper.dateForAPI(values.asset.expiry_date) : '',
        chemical_last_used: values.asset.chemical_last_used ? dateHelper.dateForAPI(values.asset.chemical_last_used) : '',
        point,
        available_to_contractor: values.asset.available_to_contractor ? 1 : 0,
        property_id: props.propertyId,
        permits: permitsPayload,
        crops: cropsPayload,
      }
    }

    assetService.storeOrUpdate(data, assetData.id).then(res => {
      if(res.code === '0000'){
        props.onSaved(res.facility);
        cancelModal();
        form.resetFields();
      } else {
        setLoading(false);
      }
    });
  }

  useEffect(() => {
      const permitValues = (assetData.permits || []).map((permit) => ({
        id: permit.id,
        crop_usage: permit.crop_usage,
        rate: permit.rate,
        rate_per: permit.rate_per || null,
        min_rate: permit.min_rate ?? null,
        min_rate_unit: permit.min_rate_unit || null,
        max_rate: permit.max_rate ?? null,
        max_rate_unit: permit.max_rate_unit || null,
        whp_harvest: permit.whp_harvest || null,
        whp_grazing: permit.whp_grazing || null,
        permit_code: permit.permit_code,
        expiry_date: permit.expiry_date ? moment(permit.expiry_date) : null,
        attachment_id: permit.attachment_id ?? (permit.attachment ? permit.attachment.id : null),
        attachment: permit.attachment || null,
      }));

      const cropValues = (assetData.crops || []).map((crop) => ({
        id: crop.id,
        crop_name: crop.crop_name,
        rate: crop.rate,
        rate_per: crop.rate_per || null,
        min_rate: crop.min_rate ?? null,
        min_rate_unit: crop.min_rate_unit || null,
        max_rate: crop.max_rate ?? null,
        max_rate_unit: crop.max_rate_unit || null,
        whp_harvest: crop.whp_harvest || null,
        whp_grazing: crop.whp_grazing || null,
        allow_use: crop.allow_use !== undefined ? !!crop.allow_use : true,
      }));

      setFields([
        {
          name: ['asset', 'title'],
          value: assetData.title || '',
        },
        {
          name: ['asset', 'available_to_contractor'],
          value: !!assetData.available_to_contractor,
        },
        {
          name: ['asset', 'category'],
          value: assetData.category,
        },
        {
          name: ['asset', 'other_category'],
          value: assetData.other_category,
        },
        {
          name: ['asset', 'type'],
          value: assetData.type,
        },
        {
          name: ['asset', 'chemical_batch_number'],
          value: assetData.chemical_batch_number,
        },
        {
          name: ['asset', 'containers'],
          value: assetData.containers,
        },
        {
          name: ['asset', 'formulation_type'],
          value: assetData.formulation_type,
        },
        {
          name: ['asset', 'rate'],
          value: assetData.rate,
        },
        {
          name: ['asset', 'other_rate'],
          value: assetData.other_rate,
        },
        {
          name: ['asset', 'chemical_last_used'],
          value: assetData.chemical_last_used ? moment(assetData.chemical_last_used) : '',
        },
        {
          name: ['asset', 'state'],
          value: assetData.state,
        },
        {
          name: ['asset', 'other_inventory_type'],
          value: assetData.other_inventory_type,
        },
        {
          name: ['asset', 'state'],
          value: assetData.state,
        },
        {
          name: ['asset', 'other_state'],
          value: assetData.other_state,
        },
        {
          name: ['asset', 'date_of_purchase'],
          value: assetData.date_of_purchase ? moment(assetData.date_of_purchase) : '',
        },
        {
          name: ['asset', 'manufacture_date'],
          value: assetData.manufacture_date ? moment(assetData.manufacture_date) : '',
        },
        {
          name: ['asset', 'description'],
          value: assetData.description || '',
        },
        {
          name: ['asset', 'container_unit'],
          value: assetData.container_unit,
        },
        {
          name: ['asset', 'container_size'],
          value: assetData.container_size || '',
        },
        {
          name: ['asset', 'remaining'],
          value: assetData.remaining || '',
        },
        {
          name: ['asset', 'fuel_type'],
          value: assetData.fuel_type || '',
        },
        {
          name: ['asset', 'other_fuel_type'],
          value: assetData.other_fuel_type || '',
        },
        {
          name: ['asset', 'other_container_unit'],
          value: assetData.other_container_unit || '',
        },
        {
          name: ['asset', 'expiry_date'],
          value: assetData.expiry_date ? moment(assetData.expiry_date) : '',
        },
        {
          name: ['asset', 'primary_object_id'],
          value: assetData.primary_object_id || '',
        },
        {
          name: ['asset', 'permits'],
          value: permitValues,
        },
        {
          name: ['asset', 'crops'],
          value: cropValues,
        },
      ]);

      if (permitValues.length) {
        setPermitAttachmentLists(
          permitValues.map((permit) => {
            const attachmentData = permit.attachment;
            if (attachmentData) {
              const attachmentPath = attachmentData.full_path || buildAttachmentUrl(attachmentData) || attachmentData.url;
              return [
                {
                  uid: `${attachmentData.id}`,
                  name: extractFileName(attachmentPath || ''),
                  status: 'done',
                  url: attachmentPath,
                },
              ];
            }
            return [];
          })
        );
      } else {
        setPermitAttachmentLists([]);
      }
    
  }, [props.propertyId, props.visibleAssetFuel, assetData]);

  const renderOptionsAssetCategory = () => {
    let options = [];
    _.forEach(assetCategories, (cat, index) => {
      options.push(
        <Option key={index} value={cat.value}>
          <div>{cat.label}</div>
        </Option>
      );
    })
    return (
      <Select
        placeholder="Select a category"
        allowClear
        size="large"
        disabled
      >
        {options}
      </Select>
    );
  }

  const renderOptionsInventoryType = () => {
    let options = [];
    _.forEach(inventoryTypes, (type, index) => {
      options.push(
        <Option key={index} value={type.value}>
          <div>{type.label}</div>
        </Option>
      );
    })
    return (
      <Select
        placeholder="Select a inventory type"
        allowClear
        size="large"
        disabled
      >
        {options}
      </Select>
    );
  }

  const renderOptionsAssetState = () => {
    let options = [];
    _.forEach(assetStates, (state, index) => {
      options.push(
        <Option key={index} value={state.value}>
          <ColorItemRow>
            <ColorItemPreview style={{backgroundColor: state.color}}></ColorItemPreview>
            <div>{state.label}</div>
          </ColorItemRow>
        </Option>
      );
    })
    return (
      <Select
        placeholder="Select a state"
        allowClear
        size="large"
      >
        {options}
      </Select>
    );
  }

  const renderOptionsFuelType = () => {
    let options = [];
    _.forEach(fuelTypes, (fuel, index) => {
      options.push(
        <Option key={index} value={fuel.value}>
          <div>{fuel.label}</div>
        </Option>
      );
    })
    return (
      <Select
        placeholder="Select a fuel type"
        allowClear
        size="large"
      >
        {options}
      </Select>
    );
  } 

  const renderOptionsFuelContainerUnit = () => {
    let options = [];
    _.forEach(fuelContainerUnits, (fuel_unit, index) => {
      options.push(
        <Option key={index} value={fuel_unit.value}>
          <div>{fuel_unit.label}</div>
        </Option>
      );
    })
    return (
      <Select
        placeholder="Select a fuel unit"
        allowClear
        size="large"
      >
        {options}
      </Select>
    );
  } 

  const renderOptionObject = (objects) => {
    let options = [];
    _.forEach(objects, (object, index) => {
      options.push(
        <Option key={object.id} value={object.id}>
          {object.name}
        </Option>
      );
    })
    return (
      <Select
        placeholder="Select an object"
        allowClear
        size="large"
      >
        {options}
      </Select>
    );
  }

  const [activeTab,setActiveTab] = useState("1");
  const onChangeTab = (key) => {
    setActiveTab(key);
  }

  const addHistory = (object, e) => {
    setVisibleHistory(true);
  }

  const cancelModalHistory = () => {
    addHistoryForm.resetFields();
    setVisibleHistory(false);
    setLoadingHistory(false);
  }

  const renderOptionsTreatmentRate = () => {
    let options = [];
    _.forEach(treatmentRates, (rate, index) => {
      options.push(
        <Option key={index} value={rate.value}>
          <div>{rate.label}</div>
        </Option>
      );
    })
    return (
      <Select
        placeholder="Select a rate"
        allowClear
        size="large"
      >
        {options}
      </Select>
    );
  }

  return(
    <>
    <AssetModalWrapper
      visible={props.visibleAssetFuel}
      onCancel={cancelModal}
      maskClosable={false}
      title={props.dataAsset.id ? <IntlMessages id="propertyPage.modal.asset.editAsset"/> : <IntlMessages id="propertyPage.modal.asset.addAsset"/>}
      footer={[
        <Button key="back" onClick={cancelModal} className="cancel-button">
          {<IntlMessages id="propertyPage.modal.cancel" />}
        </Button>,
        <Button key="submit" className="btn-success" type="primary" onClick={handleSubmit} loading={loading}>
          {<IntlMessages id="propertyPage.modal.save" />}
        </Button>,
      ]}
    >
    {
        modalLoading ?
        <Loader /> : 
        <Tabs defaultActiveKey="1" className="form-body"
        onChange={onChangeTab}
        >
       
        <TabPane tab={<IntlMessages id="propertyPage.mobModal.detailTab" />} key="1"> 
          <Form
            form={form}
            layout="vertical"
            scrollToFirstError
            fields={fields}
            id="#1"
          >
          <div>
            <Form.Item
              name={['asset', 'available_to_contractor']}
              className="isoInputWrapper"
              label="Available to contractors"
              valuePropName="checked"
            >
              <Switch checkedChildren="Yes" unCheckedChildren="No" />
            </Form.Item>
            <Form.Item
              name={['asset', 'title']}
              className="isoInputWrapper"
              label="Title"
              rules={[
                {
                  required: true,
                  message: 'This field is required',
                  whitespace: true,
                },
                {
                  max:255,
                  message: 'Title must be maximum 255 characters.'
                },
              ]}
            >
              <Input size="large" placeholder="Input asset title"/>
            </Form.Item>
            <Form.Item
              name={['asset', 'category']}
              className="isoInputWrapper"
              label="Category"
              rules={[
                {
                  required: true,
                  message: 'This field is required',
                },
              ]}
            >
              {renderOptionsAssetCategory()}
            </Form.Item>
            <Form.Item
              name={['asset', 'type']}
              className="isoInputWrapper"
              label="Inventory Type"
              rules={[
                {
                  required: true,
                  message: 'This field is required',
                },
              ]}
            >
              {renderOptionsInventoryType()}
            </Form.Item>
            <Row>
              <Col xs={{span: 24}} md={{span: assetData.type === 'fuel' ? 11 : 8}}>
              {assetData.type === 'fuel' ? 
                <Form.Item
                  name={['asset', 'fuel_type']}
                  className="isoInputWrapper"
                  label="Fuel Type"
                  rules={[
                    {
                      required: true,
                      message: 'This field is required',
                    },
                  ]}
                >
                  {renderOptionsFuelType()}
                </Form.Item> :
                <Form.Item
                  name={['asset', 'chemical_batch_number']}
                  className="isoInputWrapper"
                  label="Batch Number"
                  rules={[
                    {
                      required: true,
                      message: 'This field is required',
                    },
                  ]}
                >
                  <Input style={{ width: '100%' }} size="large" />
                </Form.Item>
              }
              </Col>
              <Col xs={{span: 24}} md={{span: assetData.type === 'fuel' ? 11 : 7, offset: assetData.type === 'fuel' ? 2 : 1}}>
                <Form.Item
                  name={['asset', 'container_unit']}
                  className="isoInputWrapper"
                  label="Units of Measurement"
                  rules={[
                    {
                      required: true,
                      message: 'This field is required',
                    },
                  ]}
                >
                  {renderOptionsFuelContainerUnit()}
                </Form.Item>
              </Col>
              {assetData.type === 'chemical' ? 
              <Col xs={{span: 24}} md={{span: 7, offset: 1}}>
                <Form.Item
                  name={['asset', 'containers']}
                  className="isoInputWrapper"
                  label="Containers"
                  rules={[
                    {
                      required: false,
                      message: 'This field is required',
                    },
                  ]}
                >
                  <InputNumber style={{ width: '100%' }} size="large" min={0} max={1000} />
                </Form.Item>
              </Col> : ''}
            </Row>
            {assetData.type === 'chemical' && (
              <Row>
                <Col xs={{span: 24}} md={{span: 11}}>
                  <Form.Item
                    name={['asset', 'formulation_type']}
                    className="isoInputWrapper"
                    label="Formulation Type"
                  >
                    <Select size="large" placeholder="Select formulation type" allowClear>
                      {FORMULATION_TYPES.map(ft => (
                        <Option key={ft.value} value={ft.value}>{ft.label}</Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            )}
            <Row>
              <Col xs={{span: 24}} md={{span: 11}}>
                  <Form.Item
                  noStyle
                  shouldUpdate={(prevValues, currentValues) => {
                    return (prevValues['asset'] && (prevValues['asset'].fuel_type !== currentValues['asset'].fuel_type));
                  }}
                  >
                  {({ getFieldValue }) => {
                      if(getFieldValue('asset')){
                        if (getFieldValue('asset').fuel_type === "other"){
                          return (
                              <Form.Item
                                name={['asset', 'other_fuel_type']}
                                className="isoInputWrapper"
                                label="Other Fuel Type"
                                rules={[
                                  {
                                    required: true,
                                    message: 'This field is required',
                                    whitespace: true
                                  },
                                  {
                                    max:255,
                                    message: 'Other Fuel Type must be maximum 255 characters.'
                                  },
                                ]}
                              >
                                <Input size="large" placeholder="Input other fuel type"/>
                              </Form.Item>
                          );
                        }
                      }else{
                        if (assetData.fuel_type === "other"){
                          return (
                              <Form.Item
                                name={['asset', 'other_fuel_type']}
                                className="isoInputWrapper"
                                label="Other Fuel Type"
                                rules={[
                                  {
                                    required: true,
                                    message: 'This field is required',
                                    whitespace: true
                                  },
                                  {
                                    max:255,
                                    message: 'Other Fuel Type must be maximum 255 characters.'
                                  },
                                ]}
                              >
                                <Input size="large" placeholder="Input other fuel type"/>
                              </Form.Item>
                          );
                        }
                      }
                    }
                  }
                </Form.Item>
              </Col>
              <Col xs={{span: 24}} md={{span: 11, offset: 2}}>
                <Form.Item
                  noStyle
                  shouldUpdate={(prevValues, currentValues) => {
                    return (prevValues['asset'] && (prevValues['asset'].container_unit !== currentValues['asset'].container_unit));
                  }}
                  >
                  {({ getFieldValue }) => {
                      if(getFieldValue('asset')){
                        if (getFieldValue('asset').container_unit === "other"){
                          return (
                              <Form.Item
                                name={['asset', 'other_container_unit']}
                                className="isoInputWrapper"
                                label="Other Container Unit"
                                rules={[
                                  {
                                    required: true,
                                    message: 'This field is required',
                                    whitespace: true
                                  },
                                  {
                                    max:255,
                                    message: 'Other Container Unit Type must be maximum 255 characters.'
                                  },
                                ]}
                              >
                                <Input size="large" placeholder="Input other container unit"/>
                              </Form.Item>
                          );
                        }
                      }else{
                        if (assetData.container_unit === "other"){
                          return (
                              <Form.Item
                                name={['asset', 'other_container_unit']}
                                className="isoInputWrapper"
                                label="Other Container Unit"
                                rules={[
                                  {
                                    required: true,
                                    message: 'This field is required',
                                    whitespace: true
                                  },
                                  {
                                    max:255,
                                    message: 'Other Container Unit Type must be maximum 255 characters.'
                                  },
                                ]}
                              >
                                <Input size="large" placeholder="Input other container unit"/>
                              </Form.Item>
                          );
                        }
                      }
                    }
                  }
                </Form.Item>
              </Col>
            </Row>
            <Row>
                <Col xs={{span: 24}} md={{span: 8}}>
                  <Form.Item
                    noStyle
                    shouldUpdate={(prev, curr) =>
                      prev?.asset?.container_unit !== curr?.asset?.container_unit ||
                      prev?.asset?.other_container_unit !== curr?.asset?.other_container_unit
                    }
                  >
                    {({ getFieldValue }) => {
                      const unit = getFieldValue(['asset', 'container_unit']);
                      const other = getFieldValue(['asset', 'other_container_unit']);
                      const suffix = getFuelContainerUnitSuffix(unit, other || '');
                      return (
                        <Form.Item
                          name={['asset', 'container_size']}
                          className="isoInputWrapper"
                          label="Container Size"
                          rules={[
                            {
                              required: false,
                              message: 'This field is required',
                            },
                          ]}
                        >
                          <InputNumber style={{ width: '100%' }} size="large" min={1} max={1000} addonAfter={suffix}/>
                        </Form.Item>
                      );
                    }}
                  </Form.Item>
                </Col>
                <Col xs={{span: 24}} md={{span: 7, offset: 1}}>
                  <Form.Item
                    name={['asset', 'remaining']}
                    className="isoInputWrapper"
                    label="Remaining"
                    rules={[
                      {
                        required: assetData.type === 'fuel' ? true : false,
                        message: 'This field is required',
                      },
                    ]}
                  >
                    <InputNumber style={{ width: '100%' }} size="large" min={1} />
                  </Form.Item>
                </Col>
                <Col xs={{span: 24}} md={{span: 7, offset: 1}}>
                  <Form.Item
                    name={['asset', 'expiry_date']}
                    className="isoInputWrapper"
                    label="Expiry Date"
                    rules={[
                      {
                        required: true,
                        message: 'This field is required',
                      },
                    ]}
                  >
                    <DatePicker size="large" style={{width: '100%'}} />
                  </Form.Item>
                </Col>
            </Row>
            {assetData.type === 'chemical' ? 
            <div><Row>
              <Col xs={{span: 24}} md={{span: 11}}>
                <Form.Item
                  name={['asset', 'chemical_last_used']}
                  className="isoInputWrapper"
                  label="Last Used"
                >
                  <DatePicker size="large" style={{width: '100%'}} />
                </Form.Item>
              </Col>
              <Col xs={{span: 24}} md={{span: 11, offset: 2}}>
                <Form.Item
                  name={['asset', 'rate']}
                  className="isoInputWrapper"
                  label="Usage Rate"
                >
                  {renderOptionsTreatmentRate()}
                </Form.Item>
              </Col>
            </Row>
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, currentValues) => {
                return (prevValues['asset'] && (prevValues['asset'].rate !== currentValues['asset'].rate));
              }}
            >
              {({ getFieldValue }) => {
                  if(getFieldValue('asset')){
                    if (getFieldValue('asset').rate === "other"){
                      return (
                        <Form.Item
                          name={['asset', 'other_rate']}
                          className="isoInputWrapper"
                          label="Other Rate"
                          rules={[
                            {
                              required: true,
                              message: 'This field is required',
                              whitespace: true
                            },
                            {
                              max:255,
                              message: 'Other Rate must be maximum 255 characters.'
                            },
                          ]}
                        >
                          <Input size="large" placeholder="Input other rate"/>
                        </Form.Item>
                      );
                    }
                  }
                }
              }
            </Form.Item></div> : ''}
            <Row>
              <Col xs={{span: 24}} md={{span: 11}}>
                <Form.Item
                  name={['asset', 'state']}
                  className="isoInputWrapper"
                  label="State"
                  rules={[
                    {
                      required: true,
                      message: 'This field is required',
                    },
                  ]}
                >
                  {renderOptionsAssetState()}
                </Form.Item>
              </Col>
              <Col xs={{span: 24}} md={{span: 11, offset: 2}}>
                <Form.Item
                  name={['asset', 'date_of_purchase']}
                  className="isoInputWrapper"
                  label="Date Of Purchase"
                  rules={[
                    {
                      required: assetData.type === 'fuel' ? true : false,
                      message: 'This field is required',
                    },
                  ]}
                >
                  <DatePicker size="large" style={{width: '100%'}} />
                </Form.Item>
              </Col>
            </Row>
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, currentValues) => {
                return (prevValues['asset'] && (prevValues['asset'].state !== currentValues['asset'].state));
              }}
            >
              {({ getFieldValue }) => {
                  if(getFieldValue('asset')){
                    if (getFieldValue('asset').state === "other"){
                      return (
                          <Form.Item
                          name={['asset', 'other_state']}
                          className="isoInputWrapper"
                          label="Other State"
                          rules={[
                            {
                              required: true,
                              message: 'This field is required',
                            },
                          ]}
                        >
                          <Input size="large" placeholder="Input other state"/>
                        </Form.Item>
                      );
                    }
                  }else{
                    if (assetData.state === "other"){
                      return (
                          <Form.Item
                          name={['asset', 'other_state']}
                          className="isoInputWrapper"
                          label="Other State"
                          rules={[
                            {
                              required: true,
                              message: 'This field is required',
                            },
                          ]}
                        >
                          <Input size="large" placeholder="Input other state"/>
                        </Form.Item>
                      );
                    }
                  }
                }
              }
            </Form.Item>
            <Row>
              <Col xs={{span: 24}} md={{span: 11}}>
                <Form.Item
                  name={['asset', 'manufacture_date']}
                  className="isoInputWrapper"
                  label="Manufacture Date"
                  rules={[
                    {
                      required: assetData.type === 'fuel' ? true : false,
                      message: 'This field is required',
                    },
                  ]}
                >
                  <DatePicker size="large" style={{width: '100%'}} />
                </Form.Item>
              </Col>
              <Col xs={{span: 24}} md={{span: 11, offset: 2}}>
                <Form.Item
                  name={['asset', 'primary_object_id']}
                  className="isoInputWrapper"
                  label="Location"
                  rules={[
                    {
                      required: true,
                      message: 'This field is required',
                    },
                  ]}
                >
                  {renderOptionObject(props.primaryObjects)}
            </Form.Item>
          </Col>
        </Row>
            {isChemical && (
            <Row>
              <Col xs={{span: 24}} md={{span: 24}}>
                <Tabs defaultActiveKey="permit">
                  <TabPane tab="Permit" key="permit">
                    {renderPermitTab()}
                  </TabPane>
                  <TabPane tab="Crop" key="crop">
                    {renderCropTab()}
                  </TabPane>
                </Tabs>
              </Col>
            </Row>
            )}
            <Form.Item
              name={['asset', 'attachment']}
              label="Attachments"
              className="isoInputWrapper"
            >
              <Upload
                {...uploadProps}
                fileList={attachmentFileList}
                itemRender={attachmentItemRender}
              >
                <Button icon={<UploadOutlined />}>Upload</Button>
              </Upload>
            </Form.Item>
            <Form.Item
              name={['asset', 'description']}
              className="isoInputWrapper"
              label="Description"
            >
              <Input.TextArea />
            </Form.Item>
          </div>  
      </Form>
      </TabPane>
      <TabPane tab={<IntlMessages id="propertyPage.mobModal.historyTab" />} key="2">
        <Row>
          <Col xs={{span: 7}} md={{span: 7}}>
            {(activePermission == "owner" || activePermission == "admin"|| activePermission == "modify") &&
            <Button key="submit" className="btn-create-breed" type="primary" onClick={addHistory}>
              {<IntlMessages id="propertyPage.mobModal.historyTab.addHistory" />}
            </Button>}
          </Col>
          <Col xs={{span: 15}} md={{span: 17}}>
            
          </Col>
          
        </Row>
        <br/>
        <AssetHistory assetHistory={assetHistory} updateDataAssetHistory={updateDataAssetHistory} dataId={assetData.id}/>
        <AddAssetHistoryModal        
          visibleHistory={visibleHistory} 
          cancelModal={cancelModalHistory}
          primaryObjects={props.primaryObjects}
          model='facilities'
          dataId={assetData.id}
          propertyId={props.propertyId}
          updateDataAssetHistory={updateDataAssetHistory}
        />
      </TabPane>
      <TabPane
        tab={<IntlMessages id="propertyPage.mobModal.sensorTab" />}
        key="3"
      >
        <SensorTab assetId={assetData.id} propertyId={props.propertyId} />
      </TabPane>
      <TabPane
        tab={<IntlMessages id="propertyPage.mobModal.formTab" />}
        key="4"
      >
        <FormTab assetId={assetData.id} propertyId={props.propertyId} />
      </TabPane>
      </Tabs>
      }     
    </AssetModalWrapper>
    </>
  )
}

export default EditFuelModal;

const ColorItemRow = styled.div`
  display: flex;
  align-items: center;
  line-height: 30px;
  div{
    margin: 4px;
  }
`;

const ColorItemPreview = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 2px;
`;
